import { CElementCover } from './CElementCover.js';

const CElementCoverPlugin = {
    install: (app) => {
        app.component(CElementCover.name, CElementCover);
    },
};

export { CElementCover, CElementCoverPlugin };
//# sourceMappingURL=index.js.map
